export const INITIALIZE_APP = 'INITIALIZE_APP'
export const TOGGLE_APP_STATE = 'TOGGLE_APP_STATE'
export const SET_LANGUAGE = 'SET_LANGUAGE'
export const SET_USER_ID = 'SET_USER_ID'
export const SET_SESSION_DATA = 'SET_SESSION_DATA'
